<template>
  <div class="invite">
    <div class="banner flex">
      <div class="rule" @click="onRule">活动规则</div>
    </div>
    <div class="container">
      <!-- 分享按钮 -->
      <share-btn>
        <div class="btn" @click="onCheckShare">
          <img
            src="https://web.chelaile.net.cn/mp-wx-carpool/image/invite/index/btn-invite.png"
            class="btn-img"
          />
        </div>
      </share-btn>
    </div>
    <!-- 分享人员列表 -->
    <div class="process">
      <div class="tab flex">
        <div
          class="tab-item"
          :class="{ active: activeTab === TAB_TYPE.FINISHED }"
          @click="onTab(TAB_TYPE.FINISHED)"
        >
          已完成
        </div>
        <div
          class="tab-item"
          :class="{ active: activeTab === TAB_TYPE.UNFINISHED }"
          @click="onTab(TAB_TYPE.UNFINISHED)"
        >
          未完成
        </div>
      </div>
      <div class="list">
        <div
          v-for="(item, index) in processList"
          :key="index"
          class="list-item"
        >
          <div class="flex">
            <img
              class="avatar"
              :src="
                item.avatarUrl || require('./assets/icon-avatar-default.png')
              "
            />
            <div>
              <div class="name">{{ item.nickName }}</div>
              <div class="date">{{ item.createTime }}</div>
            </div>
          </div>
          <div v-if="activeTab === TAB_TYPE.FINISHED" class="state">已完成</div>
          <div v-else class="state">未完成</div>
        </div>
        <template v-if="processList.length === 0">
          <img
            class="empty"
            src="https://web.chelaile.net.cn/mp-wx-carpool/image/invite/index/empty.png"
          />
        </template>
      </div>
    </div>
    <!-- 活动规则 -->
    <activity-rule-modal
      v-model="isShowRule"
      :activityExplain="activityExplain"
    />
  </div>
</template>
<script>
import ActivityRuleModal from './components/activity-rule-modal.vue'
import ShareBtn from './components/share-btn.vue'
import { getInviteInfo } from './api/activity-invite'
import { TAB_TYPE, TAB_TYPE_MAP } from './handler/const'
import { shareMgr, getShareLink } from '../../utils/share/index'
import { handleErrorUser } from '../../utils/error-handle/index'

export default {
  components: { ActivityRuleModal, ShareBtn },

  data() {
    return {
      TAB_TYPE,
      TAB_TYPE_MAP,
      activeTab: TAB_TYPE.FINISHED,
      invitees: {
        [TAB_TYPE.FINISHED]: [],
        [TAB_TYPE.UNFINISHED]: []
      },
      isLoading: false,
      cityId: '',
      operateActivityId: '',
      operateRelatedList: [],
      operateType: 0,
      processList: [],
      isShowRule: false, // 是否显示活动规则
      activityExplain: '', // 活动规则
      isReadyShare: true // 是否准备好分享
    }
  },
  mounted() {
    this.init()
  },
  activated() {
    this.init()
  },
  methods: {
    init() {
      const { cityId, operateActivityId } = this.$route.query || {}
      if (!cityId || !operateActivityId) {
        this.$toast('缺少必要参数！')
      } else {
        this.cityId = cityId
        this.operateActivityId = operateActivityId
        this.requestInviteInfo().then(this.shareCustomer)
      }
    },
    shareCustomer(info = {}) {
      const {
        shareContent,
        shareImage,
        operateActivityName,
        operateActivityId,
        operateRelatedList
      } = info || {}
      let activityId =
        operateRelatedList && operateRelatedList.length
          ? operateRelatedList[0].activityId
          : ''
      const userId = this.$UserService.getUserId()
      const sessionId = this.$UserService.getSessionId()
      const { protocol, host, pathname } = window.location
      const redirectUrl = `${protocol}//${host}${pathname}#/?cityId=${this.cityId}`
      const link = getShareLink({
        cityId: this.cityId,
        redirectUrl,
        inviterUserId: userId,
        inviterSessionId: sessionId,
        operateActivityId,
        activityId
      })
      console.log('share link: ', link)
      // 注册ready回调函数
      shareMgr.installReady(wx => {
        shareMgr.hideWxMenus()
        shareMgr.showWxMenus('menuItem:share:appMessage')
        wx.updateAppMessageShareData({
          title: operateActivityName || '分享领劵',
          desc: shareContent || '',
          link,
          imgUrl: shareImage || ''
        })
      })
    },
    requestInviteInfo() {
      if (this.isLoading) return Promise.reject()
      this.isLoading = true
      return getInviteInfo({
        bigCityId: this.cityId,
        operateActivityId: this.operateActivityId,
        userId: this.$UserService.getUserId()
      })
        .then(res => {
          console.log('getInvite res:', res)
          let { invitees, operateRelatedList } = res || {}

          this.activityExplain = res.activityExplain
          this.invitees = invitees
          this.operateRelatedList = operateRelatedList
          this.processList = invitees[this.activeTab]
          this.operateType = res.operateType
          return res
        })
        .catch(err => {
          console.error('requestInviteInfo err: ', err)
          if (err.code === '04') {
            handleErrorUser({ err, context: this })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    // 已完成/未完成
    onTab(type) {
      this.processList = this.invitees[type]
      this.activeTab = type
    },
    // 打开活动规则
    onRule() {
      this.isShowRule = true
    },
    // 检查分享是否准备好
    onCheckShare(e) {
      if (!this.isReadyShare) {
        e.stopPropagation()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
img {
  display: block;
}

.flex {
  display: flex;
  justify-content: center;
}

.invite {
  min-height: 100vh;
  background: #ee0e22;
  padding-bottom: calc(25px + constant(safe-area-inset-bottom));
  padding-bottom: calc(25px + env(safe-area-inset-bottom));
  box-sizing: border-box;
}

.banner {
  position: relative;
  width: 100%;
  height: 583px;
  background-image: url('./assets/activity-invite-bg.png');
  background-size: contain;
}

.rule {
  position: absolute;
  height: 20px;
  top: 25px;
  right: 0;
  background: rgba(255, 255, 255, 0.4);
  border-radius: 5px 0 0 5px;
  font-size: 13px;
  font-weight: 500;
  color: #ffffff;
  padding: 0 7px;
  display: flex;
  align-items: center;
}

@keyframes heartbeat {
  0% {
    transform: scale(0.95, 0.95);
  }
  25% {
    transform: scale(1, 1);
  }
  50% {
    transform: scale(1.05, 1.05);
  }
  75% {
    transform: scale(1, 1);
  }
  100% {
    transform: scale(0.95, 0.95);
  }
}
.container {
  height: 48px;
  margin: 15px 0 30px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.btn {
  width: 278px !important;
  height: 48px;
  border-radius: 25px;
  padding: 0;
  animation: heartbeat 0.8s infinite;
}

.btn-img {
  width: 278px;
  height: 48px;
}

.process {
  width: calc(100% - 30px);
  background: #ffffff;
  border-radius: 14px;
  margin: 0 15px;
  padding: 25px 0 10px 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.tab {
  width: 306px;
  height: 38px;
  background: #ffffff;
  border-radius: 4px;
  border: 1px solid #fc4c44;
  margin-bottom: 10px;
}

.tab-item {
  flex: 1;
  height: 100%;
  line-height: 38px;
  color: #fc4c44;
  text-align: center;
  font-size: 14px;
  font-weight: 500;
}

.active {
  color: #ffffff;
  background: #fc4c44;
}

.list {
  min-height: 254px;
}

.list-item {
  width: 295px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 70px;
  border-bottom: 1px solid #f7cc8e;
}

.avatar {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  margin: 0 12px 0 3px;
}

.name {
  font-size: 15px;
  font-weight: 500;
  color: #333333;
  line-height: 21px;
  max-width: 150px;
}
.date {
  font-size: 13px;
  font-weight: 400;
  color: #666666;
  line-height: 18px;
}
.state {
  font-size: 13px;
  font-weight: 400;
  color: #fc4c44;
}
.empty {
  width: 100px;
  height: 66px;
  margin-top: 100px;
  /* margin: 200px auto; */
}
</style>
